import $ from 'jquery';

class Select {
    constructor() {
        this.worship = $("#worship");
        this.education = $("#education");
        this.mission = $("#mission");
        this.all_btn = $("#all-btn");
        this.w_btn = $("#w-btn");
        this.e_btn = $("#e-btn");
        this.m_btn = $("#m-btn");
        this.check_all = true;
        this.check_w = false;
        this.check_e = false;
        this.check_m = false;

        if(this.worship) {
            this.events();
        }
    }

    // events
    events() {
        this.all_btn.on('click',this.selectAll.bind(this));
        this.w_btn.on('click', this.selectW.bind(this));
        this.e_btn.on('click', this.selectE.bind(this));
        this.m_btn.on('click', this.selectM.bind(this));
    }

    // methods
    selectAll(e) {
        if(this.check_all) {

        } else if(this.check_w) {
            this.check_w = false;
            this.w_btn.removeClass('active');
            this.education.removeClass('hide');
            this.mission.removeClass('hide');
            this.check_all = true;
            this.all_btn.addClass('active');
        } else if(this.check_e) {
            this.check_e = false;
            this.e_btn.removeClass('active');
            this.worship.removeClass('hide');
            this.mission.removeClass('hide');
            this.check_all = true;
            this.all_btn.addClass('active');
        } else if(this.check_m) {
            this.check_m = false;
            this.m_btn.removeClass('active');
            this.worship.removeClass('hide');
            this.education.removeClass('hide');
            this.check_all = true;
            this.all_btn.addClass('active');
        }
    }

    selectW(e) {
        if(this.check_w) {

        } else if(this.check_all) {
            this.check_all = false;
            this.all_btn.removeClass('active');
            this.education.addClass('hide');
            this.mission.addClass('hide');
            this.check_w = true;
            this.w_btn.addClass('active');
        } else if(this.check_e) {
            this.check_e = false;
            this.e_btn.removeClass('active');
            this.worship.removeClass('hide');
            this.education.addClass('hide');
            this.check_w = true;
            this.w_btn.addClass('active');
        } else if(this.check_m) {
            this.check_m = false;
            this.m_btn.removeClass('active');
            this.worship.removeClass('hide');
            this.mission.addClass('hide');
            this.check_w = true;
            this.w_btn.addClass('active');
        }
    }

    selectE(e) {
        if(this.check_e) {

        } else if(this.check_all) {
            this.check_all = false;
            this.all_btn.removeClass('active');
            this.worship.addClass('hide');
            this.mission.addClass('hide');
            this.check_e = true;
            this.e_btn.addClass('active');
        } else if(this.check_w) {
            this.check_w = false;
            this.w_btn.removeClass('active');
            this.worship.addClass('hide');
            this.education.removeClass('hide');
            this.check_e = true;
            this.e_btn.addClass('active');
        } else if(this.check_m) {
            this.check_m = false;
            this.m_btn.removeClass('active');
            this.education.removeClass('hide');
            this.mission.addClass('hide');
            this.check_e = true;
            this.e_btn.addClass('active');
        }
    }

    selectM(e) {
        if(this.check_m) {

        } else if(this.check_all) {
            this.check_all = false;
            this.all_btn.removeClass('active');
            this.worship.addClass('hide');
            this.education.addClass('hide');
            this.check_m = true;
            this.m_btn.addClass('active');
        } else if(this.check_w) {
            this.check_w = false;
            this.w_btn.removeClass('active');
            this.worship.addClass('hide');
            this.mission.removeClass('hide');
            this.check_m = true;
            this.m_btn.addClass('active');
        } else if(this.check_e) {
            this.check_e = false;
            this.e_btn.removeClass('active');
            this.education.addClass('hide');
            this.mission.removeClass('hide');
            this.check_m = true;
            this.m_btn.addClass('active');
        }
    }


}

export default Select;